import { type CountryCode } from '@constants'
import { useLocation } from 'react-router-dom-v5'
import { getStmCountryFromPath } from '../utils/get-stm-country-from-path'

export const useCountryCode = (): CountryCode => {
  const { pathname } = useLocation()
  return getStmCountryFromPath(pathname)
}
